//Libs
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
//Componentes Material
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
//Modelos
import QuestionarioOpcaoResposta from '../../models/QuestionarioOpcaoResposta';
import ErroQuestionarioOpcao from '../../models/ErroQuestionarioOpcao';

/**
 * Componente para opções de resposta numéricas
 */
class QuestaoEscolhaOpcaoValor extends Component {
    constructor(props) {
        super(props);
        //Bindings
        this.handleValorChange = this.handleValorChange.bind(this);
    }

    /**
     * Verifica se um valor é um número decimal, positivo ou negativo
     * @param {String} valor Valor a ser validado
     * @returns {Boolean} Retorna verdadeiro caso o valor seja um número
     */
    validarValor(valor) {
        //Expressão regular para validação
        const regex = /^-?\d*,?\d*$/g;
        //Verifica se o valor é válido
        return regex.test(valor);
    }

    /**
     * Converte um número para uma string, trocando o ponto por vírgula
     * @param {Number} valor Valor a ser convertido
     * @returns {String} Valor convertido para string
     */
    converterParaString(valor) {
        return valor.toString().replace('.', ',');
    }

    /**
     * Trata o evento de alteração do campo
     * @param {*} event Dados do evento de alteração
     */
    handleValorChange(event) {
        //Não dispara a alteração caso seja somente leitura
        if (!this.props.readOnly) {
            //Obtendo valor preenchido no campo
            const valor = event.target.value;
            //Valida se o valor é um inteiro
            if (this.validarValor(valor)) {
                //Cria uma cópia do objeto
                const opcao = QuestionarioOpcaoResposta.clone(this.props.opcao);
                //Preenche o valor
                if (valor.trim() !== '')
                    opcao.valor = valor;
                else
                    opcao.valor = '';
                //Dispara o evento de alteração
                if (this.props.onChange)
                    this.props.onChange(opcao);
            }
        }
    }

    render() {
        const { opcao, erros } = this.props;

        let value = '';
        if (opcao.valor !== null && opcao.valor !== undefined)
            value = this.converterParaString(opcao.valor);

        return (
            <Fragment>
                <Grid item xs >
                    <TextField
                        name="valor" 
                        label="" 
                        type="text" 
                        placeholder="Valor da resposta" 
                        variant="standard" 
                        size="small"
                        fullWidth 
                        required
                        autoFocus={this.props.focoAutomatico}
                        error={!!erros.valor}
                        helperText={erros.valor}
                        value={value} 
                        onChange={this.handleValorChange} 
                    />        
                </Grid>
            </Fragment>
        );
    }
}

QuestaoEscolhaOpcaoValor.propTypes = {
    /** Dados da opção de resposta a ser editada */
    opcao: PropTypes.instanceOf(QuestionarioOpcaoResposta).isRequired,
    /** Mensagens de erro da opção de resposta */
    erros: PropTypes.instanceOf(ErroQuestionarioOpcao),
    /** Indica se o componente terá o foco ao ser criado */
    focoAutomatico: PropTypes.bool,
    /** Evento disparado quando alguma alteração é realizada na reposta */
    onChange: PropTypes.func,
    /** Identifica se o componente é somente leitura e não permite alterações */
    readOnly: PropTypes.bool,
};

QuestaoEscolhaOpcaoValor.defaultProps = {
    erros: new ErroQuestionarioOpcao(),
    readOnly: false
};

export default QuestaoEscolhaOpcaoValor;